const SP_DATE_TIME = new Intl.DateTimeFormat("pt-BR", {
  timeZone: "America/Sao_Paulo",
  dateStyle: "short",
  timeStyle: "short",
});

/**
 * Formata um instante ISO no fuso de São Paulo (dd/mm/aa hh:mm). Retorna "—" para nulo/vazio e,
 * se a string não for uma data válida, devolve a string crua em vez de "Invalid Date".
 */
export function formatDateTimeSP(iso: string | null | undefined): string {
  if (!iso) return "—";
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return iso;
  return SP_DATE_TIME.format(date);
}
